import { forwardRef, useEffect, useRef } from "react";
import { Sidebar } from "../Sidebar/Sidebar";
import { Footer } from "../Footer/Footer";
import { Outlet } from "react-router-dom";
import Header from "@components/Header/Header";
import { useSelector } from "react-redux";
import type { RootState } from "@store/store";
import useNotifications from "@features/Notification/useNotifications";

export const MainLayout = forwardRef<HTMLElement>(() => {
	const isAuthenticated = useSelector((state: RootState) => state.user.isAuthenticated);
	const { fetchInitial } = useNotifications();
	const fetchedRef = useRef(false);

	useEffect(() => {
		if (isAuthenticated && !fetchedRef.current) {
			fetchInitial();
			fetchedRef.current = true;
		}
	}, [isAuthenticated, fetchInitial]);

	return (
		<div className="min-h-screen flex flex-col bg-[#f5f6f8]">
			<Header />
			<Sidebar />
			<div className="flex-1 ml-72 min-w-0 max-w-full">
				<main className="min-w-0 max-w-full">
					<Outlet />
				</main>
			</div>
			<Footer />
		</div>
	);
});
